import { type TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates, type TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import { Base64 } from 'js-base64';
import * as React from 'react';

import { useAdfoxContext } from 'shared/context/AdfoxContext';

import { TgbNativedescGeneralContainer } from '../TgbNativedescGeneral';
import { TgbStretchContainer } from '../TgbStretch';

import type { TTgbStretchContext } from '../../bannerTemplateTypes';

const OWN_TYPES: BannerContext['type'][] = ['tgb_stretch', 'tgb_nativedesc_general'];

type BannerContext = TTgbNativedescGeneralContext | TTgbStretchContext;

export const OwnTemplates: React.FC<React.PropsWithChildren<TAdFoxBannerTemplate>> = props => {
  const { bundleName, bundleParams } = props;

  const { bannerPlace } = useAdfoxContext();

  if (bundleName === 'banner.transfer' && bundleParams?.htmlBase64) {
    try {
      const decodedParams = Base64.decode(bundleParams.htmlBase64);
      const parsedDecodedParams = JSON.parse(decodedParams);

      if (isParsedParamsValid(parsedDecodedParams) && OWN_TYPES.includes(parsedDecodedParams.type)) {
        switch (parsedDecodedParams.type) {
          case 'tgb_nativedesc_general':
            return (
              <TgbNativedescGeneralContainer
                behavior={bannerPlace === 'bottom' ? 'wide' : 'narrow'}
                context={parsedDecodedParams}
              />
            );

          case 'tgb_stretch':
            return <TgbStretchContainer context={parsedDecodedParams} />;
        }
      }
    } catch (e) {
      console.error('[AdFox] Failed to decode/parse bundleParams', bundleParams.bannerId, e);

      return null;
    }
  }

  return <AdFoxTemplates deviceType="desktop" {...props} />;
};

function isParsedParamsValid(params: object): params is BannerContext {
  return 'type' in params;
}
